import { SETUP_HOME } from "@/lib/auth/home-path";

export const TERMS_ON_HOLD_COPY = "Terms on hold. Contact accounting.";

const APPLY_FOR_TERMS_PATH = "/dashboard/billing/terms/apply";

export function applyForTermsHref(returnTo?: string): string {
  return returnTo
    ? `${APPLY_FOR_TERMS_PATH}?returnTo=${encodeURIComponent(returnTo)}`
    : APPLY_FOR_TERMS_PATH;
}

export function companySetupHref(returnTo: string): string {
  return `${SETUP_HOME}?returnTo=${encodeURIComponent(applyForTermsHref(returnTo))}`;
}
